export const ACTUALIZAR_LIST_CHECKLIST = "ACTUALIZAR_LIST_CHECKLIST";
export const ACTUALIZAR_LIST_CHECKLISTREGS = "ACTUALIZAR_LIST_CHECKLISTREGS";
export const MODIFICAR_CHECKLIST = "MODIFICAR_CHECKLIST";
export const AGREGAR_CHECKLIST = "AGREGAR_CHECKLIST";  
export const ELIMINAR_CHECKLIST = "ELIMINAR_CHECKLIST";
export const MODIFICAR_FILTROS = "MODIFICAR_FILTROS";
export const MODIFICAR_FILTROS_RANGO = "MODIFICAR_FILTROS_RANGO";
export const MODIFICAR_FILTROS_ESTADOS = "MODIFICAR_FILTROS_ESTADOS";